module.exports = __webpack_public_path__ + "img/locationIcon.86648c7d.svg";